import { FC, useState } from 'react';

interface AvatarProps {
  initials: string;
  className?: string;
  src?: string | null;
  alt?: string;
}
const Avatar: FC<AvatarProps> = ({
  initials,
  className = '',
  src,
  alt = 'User avatar',
}) => {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  return (
    <div
      className={`avatar aspect-square shrink-0 w-12 h-12 rounded-full bg-[var(--black)] text-white flex items-center justify-center overflow-hidden font-medium text-sm ${className}`}
    >
      {src && src !== failedSrc ? (
        <div className="w-full h-full">
          <img
            src={src}
            alt={alt}
            className="object-cover"
            onError={() => setFailedSrc(src)}
          />
        </div>
      ) : (
        initials
      )}
    </div>
  );
};

export default Avatar;
